import { useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import { detectLanguage, setLanguagePreference, defaultSEO, useSEO, updateStructuredData } from '../utils/seo';
import { translations } from './translations';
import type { Language } from './translations';
import { LanguageContext } from './context';

interface LanguageProviderProps {
  children: ReactNode;
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  const [language, setLanguageState] = useState<Language>(() => detectLanguage());

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setLanguagePreference(lang);
    
    // Update URL parameter
    const url = new URL(window.location.href);
    url.searchParams.set('lang', lang);
    window.history.replaceState(null, '', url.toString());
  };

  // Update SEO when language changes
  useSEO(defaultSEO[language], true);

  // Update structured data when language changes
  useEffect(() => {
    updateStructuredData(language);
  }, [language]);

  const value = {
    language,
    setLanguage,
    translations: translations[language]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}